import { h } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";
import { route } from "preact-router";
import {
	Alert,
	Box,
	Button,
	Grid,
	Paper,
	Tooltip,
	Typography,
} from "@mui/material";
import { withStyles } from "@mui/styles";
const ColorButton = withStyles((theme) => ({
	root: {
		color: "#FFFFFF",
		backgroundColor: green[500],
		"&:hover": {
			backgroundColor: green[700],
		},
	},
}))(Button);
import { green } from "@mui/material/colors";
import PersonIcon from "@mui/icons-material/Person";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import BackButton from "../Common/BackButton";
import { AppContext } from "../../AppContext";
import LoadingButtonWithTooltip from "../Common/LoadingButtonWithTooltip";

export default function Buyers({ uid, step }) {
	const [state, setState] = useState({ ctx: undefined });
	const app = useContext(AppContext);
	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/dlbyr/" + uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState((state) => ({
							...state,
							ctx: res.pld,
						}));

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);
	useEffect(() => {


		if (step === "BLC") {
			//if (state.ctx && state.ctx.complete === false && state.ctx.sellers.length > 0) {
			var lbl = (
				<div>
					<Box display="flex" justifyContent="space-between" alignItems="flex-start">
						<Box>
							<Typography variant="h5">La liste des acquéreurs est-elle bien complète ?</Typography>
							<Typography variant="body1">
								Pour générer l'offre définitive d'achat à signer électroniquement par tous les acquéreurs,
							</Typography>
							<Typography variant="body1">
								nous devons savoir si tous les acquéreurs figurent bien dans ce dossier de vente :)
							</Typography>
						</Box>
					</Box>
				</div>
			);

			var actions = (
				<ColorButton
					variant="contained"
					style="margin-left: 10px;"
					onClick={() => {
						app.refPopUp.current.handleChangeState(
							{
								opened: true,
								type: "002",
								params: {
									yes_action: () => {
										compl();
									},
									title: "Attention",
									body: (
										<div>
											<Typography variant="body1" gutterBottom>
												Confirmez-vous que tous les acquéreurs sont bien présents?
											</Typography>
											<Typography variant="h5" gutterBottom>
												L'offre définitive d'achat sera émise immédiatement en cas de réponse positive.
											</Typography>
										</div>
									),
								}
							}
						)

					}}
				>
					OUI
				</ColorButton>
			);
			app.refHeader.current.handleChangeState({
				guidelines: {
					message: lbl,
					actions: [actions],

				}
			})
		}
		// if (state.ctx.oabs && !state.ctx.blc) {
		// 	var lbl = (
		// 		<div>
		// 			<Typography variant="h4">L'offre a été acceptée, il faut maintenant la formaliser</Typography>
		// 			<Typography variant="body1">- Etablir la liste complète des acquéreurs</Typography>
		// 			<Typography variant="body1">- Que tous les acquéreurs signent la proposition d'achat</Typography>
		// 		</div>
		// 	);
		// 	var actions = null;

		// 	actions = (
		// 		<Button variant="contained" onClick={compl}>
		// 			La liste des acquéreurs est complète
		// 		</Button>
		// 	);

		// 	var icon = <CircularProgressWithLabel mode="count" num={state.ctx.mandate + state.ctx.psfp} tot={2} />;
		// 	app.refHeader.current.handleChangeState({
		// 		guidelines: {
		// 			message: lbl,
		// 			actions: actions,
		// 			icon: icon,
		// 			severity: warning
		// 		}
		// 	})
		// 	return;
		// }
		// if (state.ctx.oabs && state.ctx.blc && !state.ctx.osb) {
		// 	var lbl = (
		// 		<div>
		// 			<Typography variant="h4">
		// 				L'offre d'achat a été générée, il faut maintenant que tous les acquéreurs signent la proposition d'achat
		// 			</Typography>
		// 		</div>
		// 	);
		// 	var actions = null;

		// 	actions = (
		// 		<Button variant="contained" onClick={() => (window.location.href = "/signdoc/" + state.ctx.mandate_uid)}>
		// 			Signer
		// 		</Button>
		// 	);

		// 	var icon = <CircularProgressWithLabel mode="count" num={state.ctx.mandate + state.ctx.psfp} tot={2} />;
		// 	app.refHeader.current.handleChangeState({
		// 		guidelines: {
		// 			message: lbl,
		// 			actions: actions,
		// 			icon: icon,
		// 			severity: warning
		// 		}
		// 	})
		// 	return;
		// }
		// if (state.ctx.oabs && state.ctx.blc && state.ctx.osb) {
		// 	var lbl = (
		// 		<div>
		// 			<Typography variant="h4">L'offre d'achat a été signée, il faut maintenant que tous les vendeurs la contre-signent </Typography>
		// 		</div>
		// 	);
		// 	var actions = null;

		// 	var icon = <CircularProgressWithLabel mode="count" num={state.ctx.mandate + state.ctx.psfp} tot={2} />;
		// 	app.refHeader.current.handleChangeState({
		// 		guidelines: {
		// 			message: lbl,
		// 			actions: actions,
		// 			icon: icon,
		// 			severity: warning
		// 		}
		// 	})
		// 	return;
		// }
	}, [state]);
	const compl = () => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/a8f8ed7f832d43828453998eaed3f917/" + uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						//window.location.href = "/buyers/" + uid;
						window.location.href = "/1fdf58e512f54752959b369588380557/" + uid
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	const gotodu = (uid) => {
		window.location.replace("/du/" + uid);
	};
	if (state.ctx === undefined) return;
	return (
		<div style="">

			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Paper style="padding: 10px">
						<Box display="flex" justifyContent="space-between" alignItems="center">
							<Box>
								<Box display="flex" justifyContent="flex-start" alignItems="center">
									<Box>
										{/* <Tooltip title="Revenir au dossier">
											<ArrowBackIosIcon
												onClick={() => {
													window.location.href = "/1fdf58e512f54752959b369588380557/" + uid;
												}}
											/>
										</Tooltip> */}

										<BackButton tooltip={"Revenir au dossier"} from={"/1fdf58e512f54752959b369588380557/" + uid} />
									</Box>
									<Box>
										<Typography variant="h5">
											Gestion des acquéreurs
										</Typography>
									</Box>
								</Box>
							</Box>
							<Box>
								<Box display="flex" justifyContent="flex-end" alignItems="center">
									<Box></Box>
									<Box>
										<Button
											variant={"contained"}
											disabled={state.ctx.osb}
											onClick={() => {
												state.ctx.osb
													? app.refPopUp.current.handleChangeState(
														{
															opened: true,
															type: "002",
															params: {
																yes_action: () => {

																	app.refPopUp.current.handleChangeState(
																		{
																			opened: true,
																			type: "008",
																			users: state.ctx.buyers,
																			uid: uid,
																			src: "dus",
																			side: "AC"
																		}
																	)

																},
																title: "Attention",
																body: (
																	<div>
																		<Typography variant="body1" gutterBottom>
																			L'offre définitive d'achat a déjà été émise, une modification apportée à un ou plusieurs
																			acquéreurs va entraîner son annulation et un nouveau processus de signature.
																		</Typography>
																		<Typography variant="h5" gutterBottom>
																			Voulez vous vraiment rajouter un acquéreur ?
																		</Typography>
																	</div>
																)
															}
														}
													) :
													app.refPopUp.current.handleChangeState(
														{
															opened: true,
															type: "008",
															users: state.ctx.sellers,
															uid: uid,
															src: "dus",
															side: "AC"
														}
													)


											}}>Ajouter un acquéreur</Button>
									</Box>
								</Box>
							</Box>
						</Box>
					</Paper>
				</Grid>
				{state.ctx && state.ctx.complete && <Grid item xs={12} >
					<Paper>
						<Alert severity="success" >
							La liste des acquéreurs est complète
						</Alert>
					</Paper>

				</Grid>}
				{state &&
					state.ctx &&
					state.ctx.buyers.map((s) => {
						return (
							<Grid item xs={12} md={6} key={s.uid}>
								<Paper style="padding: 10px;">
									{" "}
									<Box display="flex" justifyContent="space-between" alignItems="space-between">
										<Box>
											<Box display="flex" justifyContent="flex-end" alignItems="center">
												<Box>
													<PersonIcon style="margin-right:10px;" />
												</Box>
												<Box>
													<Typography onClick={() => gotodu(s.uid)}>
														{s.name}
													</Typography>
												</Box>
											</Box>
										</Box>
										<Box>
											<Box display="flex" justifyContent="flex-end" alignItems="space-between">
												<Box>

												</Box>
											</Box>
										</Box>
									</Box>
								</Paper>
							</Grid>
						);
					})}
			</Grid>
		</div>
	);
}
